import { InputTypes, validFormElementValue } from '../../utils/validateFormElement';
import BaseComponent from '../BaseComponent';

const NAME = 'FormComponent';
export const TITLE_PATTERNS = {
	small: 'small'
};

export default class FormComponent extends BaseComponent {
	static get NAME() {
		return NAME;
	}

	get data() {
		return this._data;
	}

	set data(data) {
		this._data = data;
		this.render();
	}

	get value() {
		return this._value;
	}

	set value(value) {
		const previousValue = this._value;
		this._value = value;
		this.afterValueChange(value, previousValue);
	}

	get dependentQuestion() {
		return this._dependency;
	}

	set dependentQuestion(_dependency) {
		if (this.data.beforeDependentQuestionChange) {
			this.data.beforeDependentQuestionChange(_dependency, this._dependency);
		}
		this._dependency = _dependency;
	}

	get formElementData() {
		return this._formElementData;
	}

	set formElementData(elementObject) {
		this._formElementData = elementObject;
	}

	constructor(containerElement, config) {
		super(containerElement);
		if (!containerElement) {
			throw new Error('Container element not found');
		}
		this.containerEl = containerElement;
		this._changeCallbacks = [];
		this._nextButtonCallbacks = [];
		if (config?.data) this.data = config.data;
	}

	updateData(_data) {
		this.data = {
			...this.data,
			..._data
		};
	}

	onChange(callback) {
		this._changeCallbacks.push(callback);
	}

	nextButtonClick() {
		for (const callback of this._nextButtonCallbacks) {
			callback();
		}
	}

	afterValueChange(value, previousValue) {
		for (const callback of this._changeCallbacks) {
			callback(value, previousValue);
		}
	}

	render() {
		this.remove();

		const titleMarkup = this.renderHeadingTitles();
		const markup = this.markup(this.value, this.data, titleMarkup);

		this._innerContainer = document.createElement('div');
		this._innerContainer.insertAdjacentHTML('beforeend', markup);
		this.containerEl.append(this._innerContainer);

		this.afterRender(this.data);
	}

	renderHeadingTitles() {
		let title = this.data?.question || '';
		let subTitle = this.data?.questionPrefix || '';
		let prefixTitle = '';
		const extraSubtitle = this.data?.extraSubtitle || '';

		// TODO epi config should be changed to to handle this case
		if (this.data?.titlePattern === TITLE_PATTERNS.small) {
			title = '';
			subTitle = `${this.data?.questionPrefix} ${this.data?.question}`;
			prefixTitle = this.data?.questionTitle;
		}

		const titleElement = this.renderTitle(title);
		const subTitleElement = this.renderSubTitle(subTitle);
		const prefixTitleElement = this.renderPrefixTitle(prefixTitle);
		const extraSubtitleElement = this.renderExtraSubtitle(extraSubtitle);

		return `<div class="lta-heading">
                    ${prefixTitleElement}
                    ${subTitleElement}
                    ${titleElement}
                    ${extraSubtitleElement}
                </div>`;
	}

	renderTitle(title) {
		return title ? `<div class="lta-heading-title u-mb-5 sm:u-mb-3">${title}</div>` : '';
	}

	renderSubTitle(subTitle) {
		return subTitle ? `<div class="lta-heading-subtitle u-mb-2 sm:u-mb-1">${subTitle}</div>` : '';
	}

	renderPrefixTitle(prefixTitle) {
		return prefixTitle ? `<div class="u-caption1 u-mb-3">${prefixTitle}</div>` : '';
	}

	renderExtraSubtitle(extraTitle) {
		return extraTitle ? `<div class="lta-heading-subtitle u-mb-2">${extraTitle}</div>` : '';
	}

	performActionOnLoad() {
		return true;
	}

	afterRender() {}

	markup() {
		throw new Error('markup method must be defined in the child component');
	}

	remove() {
		this._innerContainer?.remove();
	}

	validate() {
		return this.data?.isOptional ? true : validFormElementValue(this.getValueFromElement(), this.formElementData);
	}

	getValueFromElement(isSearchInput = false, elementObject = this.formElementData) {
		let formElementValue;
		switch (elementObject.inputType) {
			case InputTypes.SELECTOR_INPUT: {
				formElementValue = isSearchInput ? elementObject.value : elementObject.formElement?.value;
				break;
			}

			default:
				throw new Error(
					'getValueFromElement is not defined for this component: it should return the value set with this component'
				);
		}
		return formElementValue;
	}

	setDependentQuestion() {
		throw new Error('setDependentQuestion method is not defined in child');
	}

	setupValueObject(value) {
		this.value = {
			...this.data,
			value: value
				? {
						...value
				  }
				: undefined
		};

		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}

	shouldShowNext() {
		// NOTE - This method can be overriden by Form Component to implement logic to show / hide the Next button.
		// Button should return true/false.
		return true;
	}

	reRenderQuestion(questionData) {
		return true;
	}
}
